<template>
  <div class="result">
    <template v-if="viewStyle === 'tile'">
      <CourseTile
        v-if="tileType === 'course'"
        :course="item"
        :backgroundImg="$getCourseBackground(item, 'small')"
        :gradient="$getGradient()"
        :duration="$duration.getCourseDuration(item)"
        :customClass="'result__course'"
      ></CourseTile>
      <LearningPathTile
        v-if="tileType === 'playlist'"
        :path="item"
        :backgroundImg="$getPlaylistBackground(item.id)"
        :gradient="$getGradient()"
        :duration="item.duration"
        categoryName="Learning Path"
        :difficulty="
          item.difficulty && item.difficulty[0] ? item.difficulty[0].rating : 0
        "
        :customClass="'result__playlist'"
      ></LearningPathTile>
      <VideoSearchResult
        v-if="tileType === 'video'"
        class="result__video"
        :video="item"
        @click:openVideo="openVideo($event.video)"
      ></VideoSearchResult>
    </template>
    <template v-else>
      <ListResult
        v-if="tileType === 'course'"
        :type="tileType"
        :course="item"
        :tileImg="$getCourseBackground(item, 'small')"
        :duration="$duration.getCourseDuration(item)"
        :difficulty="
          item.difficulties && item.difficulties[0]
            ? item.difficulties[0].rating
            : 0
        "
      />
      <ListResult
        v-if="tileType === 'playlist'"
        :type="tileType"
        :course="item"
        :tileImg="$getPlaylistBackground(item.id)"
        :duration="item.duration"
        :difficulty="
          item.difficulty && item.difficulty[0] ? item.difficulty[0].rating : 0
        "
      />
      <VideoSearchResult
        v-if="tileType === 'video'"
        class="result__video"
        :video="item"
        @click:openVideo="openVideo($event.video)"
      ></VideoSearchResult>
    </template>
  </div>
</template>

<script>
import CourseTile from '@/components/layout/CourseTile.vue'
import LearningPathTile from '@/components/layout/LearningPathTile.vue'
import VideoSearchResult from '@/components/search/search-components/VideoSearchResult.vue'
import ListResult from '@/components/search/search-components/ListResult.vue'

export default {
  name: 'Result',
  props: {
    tileType: {
      type: String,
      required: true,
    },
    item: {
      type: [Array, Object],
      required: true,
    },
    viewStyle: {
      type: String,
      required: true,
    },
  },
  components: {
    CourseTile,
    LearningPathTile,
    VideoSearchResult,
    ListResult,
  },
  methods: {
    openVideo(video) {
      this.$store.dispatch('content/setPlayingVideoId', video.id)
      this.$router.push({
        name: 'course',
        params: { id: video.course_id, slug: video.course_slug },
      })
    },
  },
}
</script>

<style lang="scss">
.result {
  padding: 0;
  &__course {
    width: 100%;
    padding: 0;
  }
  &__playlist {
    width: 100%;
    padding: 0;
  }
  &__video {
    width: 100%;
  }
}
</style>
